import {
  BarChart3, Bot, Boxes, Building2, Contact, Cpu, Database, FileScan, FileSearch, Image, LayoutDashboard,
  Library, LineChart, Microscope, Palette, PenTool, Plug, Search, ShieldCheck, Sparkles, Users, Wand2, Workflow, Wrench,
} from "lucide-react";

export const ICONS = {
  BarChart3, Bot, Boxes, Building2, Contact, Cpu, Database, FileScan, FileSearch, Image, LayoutDashboard,
  Library, LineChart, Microscope, Palette, PenTool, Plug, Search, ShieldCheck, Sparkles, Users, Wand2, Workflow, Wrench,
};
